import React, { useState } from 'react';
import { STabList, STabItem } from './styled/STabbar';

interface TabbarProps {
    items: TabbarItem[];
    onChange: (status: string) => void;
}

interface TabbarItem {
    id: string;
    title: string;
    value: string;
    active: boolean;
}

const Tabbar: React.FC<TabbarProps> = ({items, onChange}) => {


    const [tabItems, updateTabItems] = useState<TabbarItem[]>(items);

    const toggleActive = (tabbarItem: TabbarItem) => {
        const clonedItems = items.slice(0);
        clonedItems.map((item) => item.active = false);
        const found = clonedItems.find((item) => item.title === tabbarItem.title);
        if (found) {
            found.active = true;
            onChange(found.value);
        }
        updateTabItems(clonedItems);
    }

    return <STabList id='tabbar'>
        {tabItems.map((item, index) => {
            return <STabItem id={`${item.id}-users-tab`} key={index} onClick={() => toggleActive(item)} value={item.value} active={item.active}>{item.title}</STabItem>
        })}
    </STabList>
};

export default Tabbar;
